<template>
    <div>
        <section class="goodsBox">
            <!--S 检索-->
            <el-form :model="searchGLForm" inline class="searchForm noBtmForm">
                <el-form-item label="快递生成日期">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        :noQuick="1"
                        @twoDateObtain="twoDateReceive"
                        :startvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[0]:''"
                        :endvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[1]:''" >
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
                <el-form-item>
                <el-button type="primary" @click="querySubmit">查询</el-button>
                <el-button type="primary" plain @click="exportStatistics">导出</el-button>
                </el-form-item>
            </el-form>
            <!-- 注意：没有小灯泡提示的时候，要加类名pb20,有的时候就不要加 -->
            <p class="pb20">
                <el-button v-for="(item,index) in timeLimit" :key="index"  size="small" :type="index == searchGLForm.current?'primary':''" @click="dateQuery(index)">{{item}}</el-button>
            </p>
            <!--E 检索-->
            <div class="gsListTable individualiz">
                <!--S 商品列表-->
                <el-table ref="gsTable" class="gsTable comTable" border :data="expressStatisticsList" :maxHeight="tableHeight" v-loading="loading">
                    <el-table-column label="快递总数" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(-1)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.allNum}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="待发货" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(0)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.dfh}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="已发货" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(1)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.yfh}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="退货" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(2)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.th}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="已补发" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(3)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.ybf}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="无效快递" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(4)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.wxkd}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="已签收" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(5)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.yqs}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="异常签收" min-width="150">
                        <template slot-scope="scope">
                            <a @click="toStatisticsDetail(6)" tag="p" class="hand iconhand" title="点击查看详情">{{scope.row.ycqs}}</a>
                        </template>
                    </el-table-column>
                    <template slot="empty">
                        <div class="noData"><span>暂无数据</span></div>
                    </template>
                </el-table>
                <!--E 商品列表-->
            </div>
        </section>
    </div>
</template>
<script>
import api from '@/apis/api.js';
export default {
    name:'AllExpressStatisticsList',
    data () {
        return {
            searchGLForm:{
                paiTime:[],
                current:0,//当前检索时限,0：全部，1：本年度，2：本季度，3：本月 4：本周
            },
            timeLimit:['全部','本年度','本季度','本月','本周'],//检索时限
            tableHeight: window.innerHeight*.8, //表格动态高度
            expressStatisticsList: [], // 统计数据列表
            loading: false, // 加载中弹窗显示和隐藏
            patchName: '', // 获取上一个页面的name
        }
    },
    filters: {

    },
    components: {
        TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    },
    // ============================================== 监听 ==============================================
    watch: {
        '$route'(to,from) {
            this.patchName = from.name;
        }
    },
    // ============================================== 方法 ==============================================
    methods: {
        //---------------券卡规则 method End-------------
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 接收选中的日期
        twoDateReceive(info) {
            this.searchGLForm.current = 0;
            if(info&&info.length>0) {
                this.searchGLForm.paiTime[0] = info[0];
                this.searchGLForm.paiTime[1] = info[1];
            } else {
                this.searchGLForm.paiTime = [];
            }
        },
        // 固定日期检索
        dateQuery(type) {
            this.searchGLForm.current = type;
            let start = new Date();
            let end = new Date();
            if(type == 0) {
                this.searchGLForm.paiTime = [];
            } else if(type == 1) {
                let nian = start.getFullYear();
                // start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                this.searchGLForm.paiTime[0] = `${nian}-01-01`;
                this.searchGLForm.paiTime[1] = end;
            } else if(type == 2) {
                // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                let nian = start.getFullYear();
                let yue = start.getMonth()+1;
                if(yue<4) {
                    yue = '01';
                } else if(yue<7) {
                    yue = '04';
                } else if(yue<10) {
                    yue = '07';
                } else {
                    yue = '10';
                }
                this.searchGLForm.paiTime[0] = nian + '-' + yue + '-' + '01';
                this.searchGLForm.paiTime[1] = end;
            } else if(type == 3) {
                // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                let nian = start.getFullYear();
                let yue = start.getMonth()+1;
                this.searchGLForm.paiTime[0] = nian + '-' + (yue>10?yue:`0${yue}`) + '-' + '01';
                this.searchGLForm.paiTime[1] = end;
            } else if(type == 4) {
                let day = start.getDay() || 7;
                if(day) {
                    day = day - 1;
                } else {
                    day = 0;
                }
                start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
                this.searchGLForm.paiTime[0] = start;
                this.searchGLForm.paiTime[1] = end;
            };
            this.querySubmit();
        },
        // 查询确认事件
        querySubmit() {
            this.getExpstatisticsList();
        },
        // 获取券卡统计记录
        getExpstatisticsList() {
            this.loading = true;
            let cardParams = {
                opesource: -1,
                startdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
                enddate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
            }
            api.GET_EXPSTATISTICSLIST(cardParams).then(res => {
                this.loading = false;
                if(res.data.status == "200") {
                    this.expressStatisticsList = [];
                    if(res.data.data && res.data.data != "null") {
                        this.expressStatisticsList.push(res.data.data);
                    }
                }
            }).catch(res => {
                this.loading = false;
            })
        },
        // 查看券卡统计信息
        toStatisticsDetail(type) {
            let ticsQueryInfo = {
                opesource: -1,
                eleType: type,
                paiTime: this.searchGLForm.paiTime
            }
            sessionStorage.setItem('ticsQueryInfo',JSON.stringify(ticsQueryInfo));
            this.$router.push({
                name: '快递统计详情',
            })
        },
        // 导出数据列表
        exportStatistics() {
            let exportParams = {
                opesource: -1,
                startdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
                enddate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
            }
            api.GET_URLFOREXPSTATISTICSLIST(exportParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        }
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        // 固定日期检索
        this.dateQuery(0)
        // // 获取券卡统计记录
        // this.getExpstatisticsList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    },
    activated() {
        if(this.patchName != '快递统计详情') {
            if(this.patchName) {
                this.searchGLForm = {
                    paiTime:[],
                    current:1,//当前检索时限,0：全部，1：本年度，2：本季度，3：本月 4：本周
                }
                // 固定日期检索
                this.dateQuery(0)
                // // 获取券卡统计记录
                // this.getExpstatisticsList();
                //在dom渲染之后
                setTimeout(()=>{
                    this.getHeight();
                },200)
            }
        }
    },
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.pb20{margin-bottom: 20px;}
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable em{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    color:
    #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px;width:auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
.gsTable .hand{cursor: pointer;font-size: 14px;}
.el-table>>>thead.is-group th{background: #f2f3f5!important;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/ExpressStatistics/AllExpressStatisticsList.vue